<template>
  <div class="iframe touch" @click.stop="$store.commit('actions/SET_IFRAME_URL', '')">
    <div class="iframe__inner">
        <iframe
          style="position:absolute;border:none;width:100%;height:100%;left:0;right:0;top:0;bottom:0;"
          sandbox="allow-scripts allow-forms allow-same-origin"
          :src="url"
        ></iframe>
      <div class="iframe-close touch" @click.stop="$store.commit('actions/SET_IFRAME_URL', '')">
        <fa :icon="['fas', 'times']" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],

  watch: {
    $route () {
      this.$store.commit('actions/SET_IFRAME_URL', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe {
  background: rgba(0, 0, 0, .7);
  bottom: 10rem;
  display: flex;    
  left: 0;
  position: absolute;
  right: 32.5rem;
  top: 0;
  // width: 100%;
  z-index: var(--iframemodal-z-index);

  .iframe-close {
    background: var(--bottombar-bg-color);
    border-radius: 50%;
    bottom: 5rem;
    box-shadow: 0.15em 0.25em 0.35em rgba(0, 0, 0, 0.45);
    height: 5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 5rem;
    z-index: 10;

    svg {
      font-size: 2.6rem;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }  

  &__inner {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
